module.exports = __webpack_public_path__ + "img/gaixie.91902577.svg";